import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsCurrentTrafoIP, MultiOptDetails_5DS, MultiOptDetails_8DS, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-current-transformer',
  templateUrl: './ds-current-transformer.component.html',
  styleUrls: ['./ds-current-transformer.component.css']
})
export class DsCurrentTransformerComponent implements OnInit, OnChanges {

  @Input() dsCurrentTrafoObj: DsCurrentTrafoIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  isCbCtOpt1Applicable: boolean = false;
  isCbCtOpt2Applicable: boolean = false;
  cbctOpt1: string = "CBCT Dia (mm)";
  cbctOpt2: string = "CBCT W (mm)";
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsCurrentTrafoObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

  addNewctMouldBlock() {
    this.dsCurrentTrafoObj.addCtMouldDS(new MultiOptDetails_8DS("", "", "", "", "", "", "", ""));
  }
  removectMouldBlock(_crDS: MultiOptDetails_8DS) {
    if (_crDS) {
      this.dsCurrentTrafoObj.removeCtMouldDS(_crDS);
    }
  }

  isCBCTApplicable(_ctDS: MultiOptDetails_8DS): boolean {
    if (_ctDS.type3) { // Check if the value is selected
      if (_ctDS.type3 == "001") return true; // Applicable when option is Special Req
      else {
        _ctDS.type4 = "";
        _ctDS.type5 = "";
        _ctDS.type6 = "";
        _ctDS.type7 = "";
        _ctDS.type8 = "";
        return false;
      }
    }
  }
  checkCbCtTypeValue(_ctDS: MultiOptDetails_8DS) {
    if (_ctDS.type5) {
      if (_ctDS.type5 == "001") {
        this.cbctOpt1 = "CBCT Dia (mm)";
        this.isCbCtOpt1Applicable = true;
        this.isCbCtOpt2Applicable = false;
        _ctDS.type6 = "";
      }
      else {
        this.cbctOpt1 = "CBCT L (mm)";
        this.cbctOpt2 = "CBCT W (mm)";
        this.isCbCtOpt1Applicable = true;
        this.isCbCtOpt2Applicable = true;
      }
    }
  }

  sectionNoteChangePM(_event: any) {
    this.dsCurrentTrafoObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsCurrentTrafoObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsCurrentTrafoObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Class of Insulation", !!this.dsCurrentTrafoObj.insulationCl, " required to save Datasheet."),
        new ValidationItem("Instruments Safety Factor", !!this.dsCurrentTrafoObj.instruSafety, " required to save Datasheet."),
        new ValidationItem("Short Time Current Duration", !!this.dsCurrentTrafoObj.ctShortTimeCurrDr, " required to save Datasheet."),
        new ValidationItem("Minimum Primary Balance", !!this.dsCurrentTrafoObj.minPrimBal, " required to save Datasheet."),
        new ValidationItem("Basic Insulation Level", !!this.dsCurrentTrafoObj.basicInsuLvl, " required to save Datasheet."),
        new ValidationItem("EE Note", !!this.dsCurrentTrafoObj.sectionNoteEE, " required to save Datasheet.")
      );
      if (this.dsCurrentTrafoObj.isCtShortTimeCurrDrSpecReqApplicable) {
        _validList.push(new ValidationItem("Short Time Current Detail", !!this.dsCurrentTrafoObj.ctShortTimeCurrDrDetail, " required to save Datasheet."));
      }
      // for (let i = 0; i < this.dsCurrentTrafoObj.ctMould.length; i++) {
      //   let ct = this.dsCurrentTrafoObj.ctMould[i];
      //   _validList.push(
      //     new ValidationItem("CT Mould #" + (i + 1), !!ct.type1, " required to save Datasheet."),
      //     new ValidationItem("CT Mould Details #" + (i + 1), !!ct.type2, " required to save Datasheet."),
      //     new ValidationItem("CBCT #" + (i + 1), !!ct.type3, " required to save Datasheet.")
      //   );
      // }
    }

    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsCurrentTrafoObj.sectionNotePM, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      _validList.push(new ValidationItem("ME Note", !!this.dsCurrentTrafoObj.sectionNoteME, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsCurrentTrafoObj.insulationCl || !this.dsCurrentTrafoObj.instruSafety ||
        !this.dsCurrentTrafoObj.ctShortTimeCurrDr || !this.dsCurrentTrafoObj.minPrimBal ||
        !this.dsCurrentTrafoObj.basicInsuLvl || !this.dsCurrentTrafoObj.sectionNoteEE) {
        return false;
      }
      if (this.dsCurrentTrafoObj.isCtShortTimeCurrDrSpecReqApplicable && !this.dsCurrentTrafoObj.ctShortTimeCurrDrDetail) return false;
      // for (let ct of this.dsCurrentTrafoObj.ctMould) {
      //   if (!ct.type1 || !ct.type2 || !ct.type3) return false;
      // }
    }
    if (this.hasAccessPM) {
      if (!this.dsCurrentTrafoObj.sectionNotePM) return false;
    }
    if (this.hasAccessME) {
      if (!this.dsCurrentTrafoObj.sectionNoteME) return false;
    }
    return true;
  }

}

